import { AddressMethod } from "src/components/shared-components/interfaces/address-method";

export class Address {
  public id: number = 0;
  public instanceGUID: string = "";
  public address: string = "";
  public name: string = "";
  public fullName: string = "";
  public hiLevelDataFormat: string = "";
  public idNormalImage: number = 0;
  public lastState: string = "";
  public statesCount: number = 0;
  public userLanguage: string = "";
  public lastValue: string = "";
  public lastTechValue: string = "";
  public lastValueTimestamp: string = "";
  public quality: string = "";
  public nRoom: string = "";
  public roomDescription: string = "";
  public translatedNRoom: string = "";
  public translatedRoomDescription: string = "";
  public measureUnit: string = "";
  public vimarProperty: string = "";
  public deviceRoomProperty = null;
  public idDeviceKind: number = 0;
  public states: string = "";
  public methodsString: string = "";
  public methods1031: string = "";
  public methods1033: string = "";
  public methods1034: string = "";
  public methods1036: string = "";
  public methods1040: string = "";
  public methods: string = "";
  public isAVariable: boolean = false;
  public readOnly: boolean = false;
  public methodsLoaded: boolean = false;
  public methodsCount: number = 0;
  public counterGranularity: string = "";
  public minAllowedValue: number | null = null;
  public maxAllowedValue: number | null = null;
  public minAllowedValueLog: number | null = null;
  public maxAllowedValueLog: number | null = null;

  constructor(address?: any) {
    if (address) {
      Object.assign(this, address);
    }
  }

  stringify(): string {
    return JSON.stringify(this);
  }

  /**
   * Load current methods string by lanuage language
   *
   * @param language
   * @returns
   */
  public loadMethodStringByLanguage(language: string): string {
    let methodsOnLanguage: string = "";
    switch (language) {
      case "en":
        methodsOnLanguage = this.methods1033;
        break;
      case "de":
        methodsOnLanguage = this.methods1031;
        break;
      case "es":
        methodsOnLanguage = this.methods1034;
        break;
      case "it":
        methodsOnLanguage = this.methods1040;
        break;
      case "fr":
        methodsOnLanguage = this.methods1036;
        break;
      default:
        break;
    }

    if (methodsOnLanguage === "") {
      methodsOnLanguage = this.methodsString;
    }

    if (methodsOnLanguage === "") {
      methodsOnLanguage = this.methods;
    }

    return methodsOnLanguage;
  }

  /**
   * Split specific address methods into complex object
   *
   * @param methods String methods to split
   * @returns
   */
  public SplitMethods(methods: string): Array<AddressMethod> {
    if (methods != "") {
      const listMethods: Array<string> = methods.split("|");

      return listMethods.map((singleMehtods: string) => {
        const methodsObject: Array<string> = singleMehtods.split("=");

        return {
          value: methodsObject[1],
          name: methodsObject[0],
        };
      });
    }
    return [];
  }

  public ParseNewValue(value: string): string {
    switch (this.hiLevelDataFormat) {
      case "FLOAT":
        value = value.replace(",", ".");
        break;
      default:
        break;
    }

    return value;
  }
}
